
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2OnTableEvent } from "../../../event/Poker2OnTableEvent";
import { Poker2Command } from "../Poker2Command";

/**
 * Shows the rabbit cam component.
 * @author Patrick
 */
export class GRBCommand extends Poker2Command {
    protected get cmdId(): string {
        return "grb";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            this.controller.dispatchEvent(new Poker2OnTableEvent("showRabbitCam", [paramObj.rCamSecs, paramObj.rCamGold]));
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
